module.exports = __webpack_public_path__ + "static/media/spinner.2b02159f.gif";